import React, { useState } from "react";

import styles from "./StoreDetails.module.scss";
import { DeleteForever, Save } from "@mui/icons-material";
import { Button, Checkbox, FormControlLabel } from "@mui/material";
import { Close, Remove, Clear } from "@material-ui/icons";

interface IStoreDetails {
  StoreName: string;
  City: string;
  Address: string;
  MinimumPickupTime: string;
  MinimumDeliveryTime: string;
  ContactNumber: number;
  NotificationNumber: number;
  NotificationEmail: String;
  DeliveryZIPCode: number;
  Longitude: number;
  Latitude: number;
  MinimumOrderValue: number;
  OpeningTime: string;
  CLosingTIme: string;
}

const details: IStoreDetails = {
  StoreName: "BLX",
  City: "Colombo",
  Address: "Colombo fort",
  MinimumPickupTime: "10 minutes",
  MinimumDeliveryTime: "20 minutes",
  ContactNumber: 7776666666,
  NotificationNumber: 7776666666,
  NotificationEmail: "BLX@test.com",
  DeliveryZIPCode: 11123,
  Longitude: 185.888,
  Latitude: 190.1234,
  MinimumOrderValue: 1000,
  OpeningTime: "10 AM",
  CLosingTIme: "12 PM",
};
const StoreDetails = () => {
  const [store, setStore] = useState<IStoreDetails>(details);
  const [days, setdays] = useState<any>(1);
  const [openDays, setopenDays] = useState([0]);
  const [week, setWeek] = useState([
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ]);
  const [selectedDays, setSelectedDays] = useState<any>([]);
  const [selectedOpenDays, setSelectedOpenDays] = useState<any>([]);
  //console.log(selectedOpenDays);
  const [openingTIme, setOpeningTIme] = useState<any>();
  const [closingTIme, setClosingTIme] = useState<any>();

  const handleStoreOpeningTImes = (value: any) => {
    selectedDays.includes(value)
      ? setSelectedDays((prev: any) =>
          prev.filter((item: any) => item !== value)
        )
      : setSelectedDays((prev: any) => [...prev, value]);
  };

  const handleStoreTimes = () => {
    const datatoSet = {
      OpenDays: selectedDays,
      OpenTIme: openingTIme,
      ClosingTIme: closingTIme,
    };

    setSelectedOpenDays([...selectedOpenDays, datatoSet]);
    setOpeningTIme(null);
    setClosingTIme(null);
    setSelectedDays([]);
  };

  const handleAllDayChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { checked } = e.target;

    if (checked) {
      setSelectedDays(week);
    } else {
      setSelectedDays([]);
    }
  };

  const removeDate = (index: any) => {
    selectedOpenDays.splice(index, 1);
    setSelectedOpenDays([...selectedOpenDays]);
  };
  return (
    <div className={styles.wrapper}>
      <div className={styles.store_details_container}>
        <div className={styles.store_name}>
          <input type="text" placeholder="Store name" value={store.StoreName} />
        </div>
        <div className={styles.store_address}>
          <input type="text" placeholder="Address" id={styles.address} />
          <input type="text" placeholder="City" id={styles.city} />
        </div>
        <div className={styles.order_time}>
          <input type="text" placeholder="Pickup time" id={styles.pickup} />
          <input type="text" placeholder="Delivery time" id={styles.delivery} />
        </div>
        <div className={styles.store_contact}>
          <input type="text" placeholder="Contact number" id={styles.contact} />
          <input
            type="text"
            placeholder="Notification number"
            id={styles.notification}
          />
        </div>
        <div className={styles.store_email}>
          <input type="text" placeholder="Email" />
        </div>
        <div className={styles.store_location}>
          <input type="text" placeholder="Longitude" id={styles.longitude} />
          <input type="text" placeholder="Latitude" id={styles.latitude} />
        </div>
        <div className={styles.store_order_zip}>
          <input
            type="text"
            placeholder="Minimum order rate"
            id={styles.order_rate}
          />
          <input type="text" placeholder="Delivery timee" id={styles.zip} />
        </div>
        <div className={styles.store_time_container}>
          {/* {openDays.map((open: any) => (
            
          ))} */}
          <div className={styles.store_time}>
            <div className={styles.open_and_close}>
              <input
                type="time"
                name="OpeningTime"
                id={styles.open}
                onChange={(e: any) => {
                  setOpeningTIme(e.target.value);
                }}
              />
              <input
                type="time"
                name="ClosingTime"
                id={styles.close}
                onChange={(e: any) => {
                  setClosingTIme(e.target.value);
                }}
              />
            </div>
            <FormControlLabel
              control={<Checkbox onChange={handleAllDayChange} />}
              label="Select all day"
            />
            <div className={styles.date_container}>
              {week.map((day: any) => (
                <>
                  {selectedDays.includes(day) ? (
                    <Button
                      onClick={() => handleStoreOpeningTImes(day)}
                      variant="contained"
                    >
                      {day}
                    </Button>
                  ) : (
                    <Button
                      variant="outlined"
                      onClick={() => handleStoreOpeningTImes(day)}
                    >
                      {day}
                    </Button>
                  )}
                  {/* <Button onClick={() => handleStoreOpeningTImes(day)}>
                    {day}
                  </Button> */}
                </>
              ))}
            </div>
          </div>
          <div className={styles.btn_container}>
            <Button variant="contained" onClick={handleStoreTimes}>
              ADD
            </Button>
          </div>
          <div className={styles.datatable}>
            <table>
              <thead>
                <tr>
                  <th>Days</th>
                  <th>Opening time</th>
                  <th>Closing time</th>
                  <th>Remove</th>
                </tr>
              </thead>
              <tbody>
                {selectedOpenDays.map((days: any, index: any) => (
                  <tr>
                    <td>
                      <div className={styles.single_day}>
                        {days.OpenDays.map((day: any) => (
                          <span>{day}</span>
                        ))}
                      </div>
                    </td>
                    <td>{days.OpenTIme}</td>
                    <td>{days.ClosingTIme}</td>
                    <td>
                      <Clear onClick={() => removeDate(index)} />{" "}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div>
          <Button variant="outlined" startIcon={<Save />} onClick={() => {}}>
            Save
          </Button>
        </div>
      </div>
    </div>
  );
};

export default StoreDetails;
